/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppThemesRequest} from '@cash-web/protos/squareup/cash/postcard/app/AppThemeApiProto.pb'
import {GetAppThemesResponse} from '@cash-web/protos/squareup/cash/postcard/app/AppThemeApiProto.pb'


export const getAppThemes = (request: GetAppThemesRequest, options?: CashRequestOptions) => post<GetAppThemesRequest, GetAppThemesResponse>("/2.0/cash/get-app-themes", request, {...options, rejectOnError: true })